import { observer } from 'mobx-react-lite';

import { IcScheduleIcon } from '@gem/icons';
import { FAB } from '@gem/ui-kit';

import usePresenter from './presenter';
import styles from './styles.m.css';

const ScheduleButton = () => {
  const presenter = usePresenter();

  return (
    <FAB
      className={styles.container}
      Icon={IcScheduleIcon}
      onClick={presenter.onClick}
      size="10"
      theme="2"
    />
  );
};

export default observer(ScheduleButton);
